"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    if (doesMatch('active')) {
        return true;
    }
    if (doesMatch('none')) {
        return false;
    }
    return false;
}
exports.default = default_1;
const doesMatch = (value) => {
    return matchMedia(`(forced-colors: ${value})`).matches;
};
